import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";

@Component({
    selector: 'app-exchange-rate',
    templateUrl: './exchange-rate.component.html',
    styleUrls: [
        './exchange-rate.component.scss',
    ]
})
export class ExchangeRateComponent implements OnChanges {
    @Input() isRate = true;
    @Input() price!: any;

    @Input() rateCoin!: any;
    @Input() exchangeCoin!: any;

    @Input() textColor = 'black'

    exchangeRate = 1;

    ngOnChanges(): void {
        this.exchangeRate = 1 / Number(this.price);
    }
}
